<template>
    <div class="with-side-panel">
      <div class="content-i">
        <div class="content-box">
          <div class="element-wrapper">
            <h6 class="element-header">
              {{ $t('dashboard.dashboard_for') + piniaUserStore().currentUser?.user?.userAccessRightsTranslation }}
            </h6>

            <Menu/>

            <div class="element-box mt-4">
                <div class="row">
                    <div class="col-lg-8 col-md-6 col-sm-12">
                        <h6 class="mt-3">Einheiten ohne Unterschrift
                            - {{ infoData?.data?.office }}</h6>
                    </div>
                    <div class="col-lg-4 col-md-6 col-sm-12 text-end">
                        <router-link class="btn btn-primary mt-3" :to="{name: 'dashboardPracticeManagerUnitsDoneByLocation'}">
                          zurück zu Standortinformationen
                        </router-link>
                    </div>
                </div>

                <div class="row mt-4">
                    <div class="col-sm-12">
                        <div class="table-responsive">
                            <table class="table table-striped">
                                <thead>
                                  <tr>
                                      <th>Kunden</th>
                                      <th style="text-align: center">Termin</th>
                                      <th style="text-align: center">Startzeit</th>
                                      <th style="text-align: center">Endzeit</th>
                                      <th style="text-align: right">Einheiten</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr v-for="(user, i) of infoData.data?.list" v-bind:key="user?.location+''+i">
                                    <td>
                                      {{ user?.unemployedFirstName+' '+user?.unemployedLastName }}
                                    </td>
                                    <td class="text-center">
                                      {{ user?.termin }}
                                    </td>
                                    <td class="text-center">
                                      {{ user?.startTime }}
                                    </td>
                                    <td class="text-center">
                                      {{ user?.endTime }}
                                    </td>
                                    <td class="text-end">
                                      {{ user?.units }}
                                    </td>
                                </tr>

                                <tr>
                                    <td class="text-start">
                                        <strong class="js-lists-values-employee-name">gesamt</strong>
                                    </td>
                                    <td class="text-end">          
                                    </td>
                                    <td class="text-end">                      
                                    </td>
                                    <td>
                                    </td>
                                    <td class="text-end">
                                        <strong class="js-lists-values-employee-name">{{ infoData?.data?.sum }}</strong>
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>

            <Pagination
                v-if="infoData?.pagination?.total_pages > 1"
                :totalPages="infoData?.pagination?.total_pages"
                :currentPage="infoData?.pagination?.current_page"
                @pagechanged="getInfoData"
            />
  
          </div>
        </div>
        <FormSidebar>
            <template #top>
                <h6 class="element-header">
                    Sidebar
                </h6>
            </template> 
        </FormSidebar>
      </div>
    </div>
</template>
  
<script setup>
import { piniaUserStore } from '@/store/piniaUserStore';
import Menu from '@/views/App/Dashboard/PracticeManager/Menu.vue';
import { RouterLink } from 'vue-router';
import { ErrorToast } from '@/components/VueToast';
import { computed, onMounted, ref } from 'vue';
import dashboardPracticeManagerService from '@/api/Dashboard/PracticeManager';
import Pagination from '@/components/Pagination.vue';
import FormSidebar from '@/components/FormSidebar.vue';
import { piniaFilterStore } from '@/store/piniaFilterStore';


const filterStore = piniaFilterStore();
const filterData   = computed(() => filterStore);
const infoData = ref({});

async function getInfoData() {
    try {
      const { data } = await dashboardPracticeManagerService.getUnsignedUnitsForLocation(filterData.value?.filterData);    
      infoData.value = data;
  
    } catch (error) {
      await ErrorToast(error);
    }
}

onMounted(() => {
  getInfoData();
})
  
</script>

<style scoped>

::v-deep(.apexcharts-legend) {
    display: block !important;
}

</style>